import { render, staticRenderFns } from "./productVolume.vue?vue&type=template&id=0ae69232&scoped=true&"
import script from "./productVolume.vue?vue&type=script&lang=js&"
export * from "./productVolume.vue?vue&type=script&lang=js&"
import style0 from "./productVolume.vue?vue&type=style&index=0&id=0ae69232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae69232",
  null
  
)

export default component.exports